export default "__VITE_ASSET__nCTpVRdT__"